const { Col, Row, Button, Form, Upload, Image, Input } = require('antd');

const FingerprintPhotoButtons = ({ title, fingerprintPhoto, field }) => {
    return (
      <Col className="buttonsBackground mb-20 pl-30 pt-30 pb-30" align="middle">
        <Row align="middle" gutter={15}>
          <Col>
            <Button
              type="primary"
              className="cmt-button secondary"
              onClick={fingerprintPhoto.openModal}
              size="large"
            >
              <span className="icon-camera-bold mr-10" />
              Tomar huella
            </Button>
          </Col>
          <Col>
            {fingerprintPhoto.fingerprintFile ? (
              <div>{fingerprintPhoto.fingerprintFile}</div>
            ) : (
              <Upload
                showUploadList={false}
                beforeUpload={(file) => {
                  fingerprintPhoto.beforeUpload(file);
                  return false;
                }}
              >
              </Upload>
            )}
          </Col>
          <Col>
            <Button
              type="primary"
              className={`deleteButton cmt-button ${fingerprintPhoto.imageSrc && !fingerprintPhoto.imageSrc?.includes("missing")
                ? "secondary non-outline"
                : "disabled non-outline"
                }`}
              onClick={fingerprintPhoto.resetImage}
              disabled={
                fingerprintPhoto.imageSrc?.includes("missing") || !fingerprintPhoto.imageSrc
              }
              size="large"
            >
              <span className="icon-system-delete" />
            </Button>
          </Col>
        </Row>
        <Row>
          {fingerprintPhoto.imageSrc && !fingerprintPhoto.imageSrc?.includes("missing") && (
            <Col lg={24} xs={24} className="mt-30">
              <Form.Item name={field}>
                <Row>
                  <Col lg={12} xs={24} span={6} align="middle">
                      <Image
                        src={fingerprintPhoto.imageSrc}
                        alt="huella paciente"
                        style={{ maxWidth: 276, height: 166 }}
                        className="mb-20"
                      />
                    <Input type="hidden" />
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Col>
    );
  };

export default FingerprintPhotoButtons;
